import { useEffect, useState } from 'react';
import { SupabaseClient } from '@supabase/supabase-js';
import { initializeSupabase } from '../services/supabase';
import { SupabaseContext } from '../hooks/use-supabase';

export const SupabaseProvider = ({ children }: { children: React.ReactNode }) => {
  const [supabase, setSupabase] = useState<SupabaseClient | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const initialize = async () => {
      try {
        console.warn('[Supabase] Initializing client...');
        const client = await initializeSupabase();
        setSupabase(client);
        console.warn('[Supabase] Client initialized, dispatching event');
        // Dispatch custom event for GTM to initialize
        const event = new CustomEvent('supabase-initialized');
        window.dispatchEvent(event);
        console.warn('[Supabase] Event dispatched');
      } catch (err) {
        const error = err instanceof Error ? err : new Error('Unknown error during initialization');
        console.error('[Supabase] Initialization error:', error);
        setError(error);
      } finally {
        setIsLoading(false);
      }
    };

    initialize();
  }, []);

  // Log error but don't block rendering
  if (error) {
    console.error('Supabase initialization error:', error);
  }

  return (
    <SupabaseContext.Provider value={{ supabase, isLoading, error }}>
      {children}
    </SupabaseContext.Provider>
  );
};
